import { HttpUtil } from '../../utils/HttpUtil'

const baseUrl = 'https://www.copel.com/ntg-api/api'

const getEnv = (key) => {
  console.log(process.env)
  const value = process.env[key];
  if (!value) {
    throw new Error(`Env ${key} not set`);
  }
  return value;
}
//const apiEndpoint = getEnv('REACT_APP_SERVER_API_ENDPOINT');
export class TechnicalStandardsService {
  static async getAll(params) {
    const filterParams = Object.entries({
      ...params,
    }).reduce(
      (accumulator, [key, value]) =>
        value === undefined ? accumulator : { ...accumulator, [key]: value },
      {},
    )

    return HttpUtil.performGetWithQueryParam(
      `${baseUrl}/norma-tecnica/view`,
      filterParams,
    )
  }

  static async getDocument(driveId, itemId) {
    return HttpUtil.performGetFile(
      `${baseUrl}/documentos/file/${driveId}/${itemId}`
    )
  }

  static async getAllCategories() {
    return HttpUtil.performGet(`${baseUrl}/categorias/list`)
  }
}
